import React from 'react';
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import {ASSET_IMAGES} from "../../utils/constants/paths";


const Logo = ({mini, mode, sx}) => {
    return (
        <Div sx={{display: "inline-flex", ...sx,maxWidth:'170px'}}>
            <Link sx={{background: mode !== "light" && '#131926'}} href={'/dashboard'}>
                {
                    !mini ?
                        <img src={ mode === "light" ? `${ASSET_IMAGES}/Blossom.png` : `${ASSET_IMAGES}/Blossom.png`} style={{maxWidth: '100%',filter: mode !== "light" && 'invert(1)'}} alt="Greenlan Logo" />
                        :
                        <img src={mode === "light" ? `${ASSET_IMAGES}/logo-short.png` : `${ASSET_IMAGES}/logo-short-white.png`}style={{maxWidth: '100%'}}  alt="Greenlan Logo" />
                }
            </Link>
        </Div>
    );
};

Logo.defaultProps = {
    mode: "light"
};

export default Logo;
